import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/events/constants';

export const columnCriteriaStripeData: {caption: string, type: ColumnTypes}[] = [
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_SOURCE], type: ColumnTypes.EVENT_SOURCE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_TYPE], type: ColumnTypes.EVENT_TYPE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_FAMILIES], type: ColumnTypes.EVENT_FAMILIES},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_CODE], type: ColumnTypes.EVENT_CODE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_DESCRIPTION], type: ColumnTypes.EVENT_DESCRIPTION},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_ATTRIBUTES], type: ColumnTypes.EVENT_ATTRIBUTES},
];

export const dateCriteriaStripeData: {caption: string, type: ColumnTypes, key: 'from' | 'to'}[] = [
    {caption: 'First Usage From', type: ColumnTypes.EVENT_FIRST_USAGE_DATE, key: 'from'},
    {caption: 'First Usage To', type: ColumnTypes.EVENT_FIRST_USAGE_DATE, key: 'to'},
    {caption: 'Last Usage From', type: ColumnTypes.EVENT_LAST_USAGE_DATE, key: 'from'},
    {caption: 'Last Usage To', type: ColumnTypes.EVENT_LAST_USAGE_DATE, key: 'to'},
];
